export const frontendTabData = {
  tabId: null
}
